function shuffle(a) {
    var j, x, i;
    for (i = a.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1));
        x = a[i];
        a[i] = a[j];
        a[j] = x;
    }
    return a;
}

var reviews = shuffle([
  {
    "product_handle": "awake-la-bleue-marine",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Romuald Ouillon",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "C'est trop cool d'avoir une montre en filet de pêche et en bouteille. Ils sont trop forts chez Awake. Je kiffe trop.",
    "reply": "",
    "created_at": "2020-05-10 05:52:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-la-bleue-marine",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Elias Dehrar",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Ma femme me l'a offerte, elle est jolie et j'ai suis impressionné par le concept.",
    "reply": "",
    "created_at": "2020-05-31 11:19:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-la-bleue-marine",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Julie",
    "email": "julie.larousse@sfr.fr",
    "location": "France",
    "body": "Ca y est j'ai reçu ma montre (la marine) ! Super contente, conforme à la photo, belles finitions.",
    "reply": "",
    "created_at": "2020-08-07 12:12:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-la-bleue-tricolore",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Thierry Jacqua",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Je ne connaissais pas du tout c'est ma copine qui me l'a offerte. Habituellement je n'achète pas de montre parce que je ne suis pas en phase éthiquement avec les grandes marques. C'est ma première montre depuis 10 ans, je suis très heureux de la porter à mon poignet et de ne pas culpabiliser de la montrer à mes amis.",
    "reply": "",
    "created_at": "2020-05-08 06:56:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-la-bleue-tricolore",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Vincent Lebras",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Je suis très satisfait de cette montre.",
    "reply": "",
    "created_at": "2020-05-09 06:30:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-la-bleue-tricolore",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Laura Saillen",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Les finitions sont très réussies pour une montre écoresponsable.",
    "reply": "",
    "created_at": "2020-05-09 06:31:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-la-bleue-tricolore",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Adrien Louboutin",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Je suis totalement fan de ma montre. Les couleurs sont trop stylées.",
    "reply": "",
    "created_at": "2020-05-27 06:25:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-la-bleue-tricolore",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Laurent Lahouze",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Franchement pour la qualité et l'originalité, le prix est vraiment raisonnable.",
    "reply": "",
    "created_at": "2020-05-29 07:35:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-la-bleue-tricolore",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Agathe Denis",
    "email": "julie.larousse@sfr.fr",
    "location": "France",
    "body": "Trop belle, super cadeau pour la fête de papa !",
    "reply": "",
    "created_at": "2020-07-10 16:55:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-la-bleue-tricolore",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Kévin Touitou",
    "email": "vincent@sunology.fr",
    "location": "France",
    "body": "Produit cohérent avec son message. Montre ultra-légère et donc très agréable à porter.",
    "reply": "",
    "created_at": "2020-08-04 07:45:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-la-bleue-tricolore",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Etienne Charbonnier",
    "email": "julie.larousse@sfr.fr",
    "location": "France",
    "body": "Montre sympa en tricolore. Tout est recyclé jusqu'au packaging, ça fait son effet.",
    "reply": "",
    "created_at": "2020-08-07 12:21:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-odyssee-canopee-mesh",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Magali Kellou",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Je trouve cette montre magnifique. Le concept est tout aussi génial. Portée elle fait vraiment son effet.",
    "reply": "",
    "created_at": "2020-06-01 06:23:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-odyssee-nenuphar",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Eugène Makindo",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "La montre Awake est une des plus belles montres que j'ai jamais achetées.",
    "reply": "",
    "created_at": "2020-05-06 06:27:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-odyssee-nenuphar-marine",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Virginie Arcoiris",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Je la porte tous les jours depuis que je l'ai reçue. Je reçois à chaque fois un compliment des personnes qui la voient pour la première fois.",
    "reply": "",
    "created_at": "2020-05-12 12:20:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-odyssee-nenuphar",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Falamak Elasri",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Excellent style. Elle ressemble à la montre Cluse, le côté écolo en plus.",
    "reply": "",
    "created_at": "2020-05-07 08:02:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-odyssee-nenuphar",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Dorothée Bardelli",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Ma montre a été livrée dans les temps et je l'adore.",
    "reply": "",
    "created_at": "2020-05-29 07:34:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-odyssee-nenuphar",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Eloà¯se Dussolier",
    "email": "julie.arrouet@free.fr",
    "location": "France",
    "body": "Sublime ! même si le bracelet me tire un peu les poiles‚ ça me fait une bonne excuse pour en acheter un autre est ce possible ? Merci !",
    "reply": "",
    "created_at": "2020-07-11 17:25:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-concept-origins-blue-reef",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Stéphane Bellan",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Depuis que je l'ai reçue en décembre, je ne la quitte plus. Un vrai coup de coeur, je l'adore.",
    "reply": "",
    "created_at": "2020-01-18 08:47:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-concept-origins-blue-reef",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Faouzi Bekkara",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Normalement je suis très exigent en matière d'horlogerie mais là le côté solaire m'a fait changer d'avis. Depuis que je l'ai je suis plus que satisfait c'est une vraie montre de qualité à un prix plus qu'abordable.",
    "reply": "",
    "created_at": "2020-01-22 16:10:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-concept-origins-blue-reef",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Paul-Louis Mecker",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "En général je n'aime pas acheter sur internet je préfère voir et essayer en boutique mais là je ne suis pas déçu. Elle est vraiment belle et très confortable à porter.",
    "reply": "",
    "created_at": "2020-02-25 07:12:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-concept-origins-blue-reef",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Charles Estarque",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Elle est très joliment faite et de bonne qualité.",
    "reply": "",
    "created_at": "2020-05-12 12:17:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-concept-origins-blue-reef",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Olivier Fanien",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Le résultat est juste parfait. On aimerait avoir d'autres bracelets disponibles sur le site.",
    "reply": "",
    "created_at": "2020-05-14 05:22:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-concept-origins-blue-reef",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Xavier Coutant",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "La Awake Origins est agréable à porter. J'aime beaucoup sa simplicité et sa touche d'originalité.",
    "reply": "",
    "created_at": "2020-05-18 06:59:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Charlotte Lemaître",
    "email": "ca@calachampa.online",
    "location": "France",
    "body": "Premier essai avec mon nouveau GoSun Fusion: j'ai mis un steak, des oignons, des pommes de terre et des haricots. Le tout a cuit en 1h30 en sachant que nous vivons en montagne et que le four a continué à fonctionner même quand il n'y avait plus de soleil. J'ai été impressionnée. J'ai essayé d'autres fours solaires et cela pouvait prendre toute la journée pour cuire à moitié quelque chose. Je ne suis même pas sûre qu'un four classique aurait pu le faire beaucoup plus rapidement!",
    "reply": "",
    "created_at": "2020-01-07 17:57:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Sylvie Dubois",
    "email": "arrouet.nelly@neuf.fr",
    "location": "France",
    "body": "Très simple d'utilisation.",
    "reply": "",
    "created_at": "2020-01-09 07:16:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "François Thuan",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Il est très pratique, il suffit juste de l'ouvrir et d'y mettre la préparation cuisinée pour que la cuisson démarre.",
    "reply": "",
    "created_at": "2020-01-12 12:25:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Sarah Forrest",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Je ne m'attendais pas à ce que la cuisson soit aussi rapide. Gosun fusion est très polyvalent et léger. Un produit solaire vraiment réussi.",
    "reply": "",
    "created_at": "2020-01-26 09:08:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Pierre-Alain Orne",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Je l'ai reçu comme cadeau de Noël. De nos jours il est quasiment impossible de promettre moins et d'offrir plus. Et pourtant c'est exactement ce que Yolk a fait. J'habite dans le sud de la France donc le soleil ne manque pas.",
    "reply": "",
    "created_at": "2020-01-29 11:32:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Samuel Dreyer",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Il fonctionne très bien et est simple à configurer. Je conseille d'utiliser du papier sulfurisé pour faciliter le nettoyage. Nous avons cuisiné de la viande, des légumes et des gàteaux et tout était bon.",
    "reply": "",
    "created_at": "2020-01-30 05:23:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Thomas Delson",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Il cuit les aliments assez rapidement et les garde au chaud.",
    "reply": "",
    "created_at": "2020-02-06 08:59:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Samira Garbi",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Nos enfants l'adorent, c'est tellement sûr et facile à utiliser qu'ils s'en servent tous seuls !",
    "reply": "",
    "created_at": "2020-02-09 16:01:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 3,
    "title": "AVIS",
    "author": "Antonin Piron",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Le four marche bien mais j'aurais aimé que ça soit moins cher quand même. J'espère que les produits solaires vont baisser leurs prix rapidement.",
    "reply": "",
    "created_at": "2020-02-10 07:08:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Mary Launay",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "La première fois que je m'en suis servie j'ai été surprise, c'était étonnamment bon ! Les saveurs ressortent clairement, bien plus qu'à la poêle ou au four traditionnel !",
    "reply": "",
    "created_at": "2020-02-13 07:57:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Jean-Marc Léger",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Nous avons reçu notre Fusion la semaine dernière, après l'avoir retiré de la boîte nous avons remarqué un léger défaut sur le boîtier métallique, rien de grave. J'ai contacté Sunology directement pour discuter de nos options et j'ai été reçu par une équipe professionnelle et très sympathique. Le problème a été résolu sans accroc. Merci.",
    "reply": "",
    "created_at": "2020-02-14 11:40:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Pénélope Flatter",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Très joli design.",
    "reply": "",
    "created_at": "2020-02-21 07:09:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Marcus Delgrande",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Il faut bien lire les instructions et faire attention à la température et vous passerez un super repas.",
    "reply": "",
    "created_at": "2020-02-23 07:55:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Judith Clouet",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Super ! Four fantastique.",
    "reply": "",
    "created_at": "2020-02-29 12:52:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Charline Mazzili",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Il est assez léger et facile à installer. Depuis le début du confinement, nous préparons régulièrement nos déjeuners dedans. Avec le beau temps, nous avons eu que de bons résultats.",
    "reply": "",
    "created_at": "2020-05-05 12:25:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Lucie Navarro",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Mes plats sont réussis et après quelques utilisations je suis beaucoup plus efficace.",
    "reply": "",
    "created_at": "2020-05-07 08:00:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Matthias Aile",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Je l'ai reçu comme prévu, en parfait état et j'ai pu m'en servir immédiatement.",
    "reply": "",
    "created_at": "2020-05-08 06:51:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Cédric Slama",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "La première utilisation en plein soleil a été très satisfaisante et rapide. La deuxième utilisation sous les nuages a fonctionné aussi. Le réchauffeur électrique a permis de terminer la cuisson. C'était bien cuit.",
    "reply": "",
    "created_at": "2020-05-13 07:14:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Rudy Bauthamy",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Il fonctionne exactement comme c'est écrit sur le site.",
    "reply": "",
    "created_at": "2020-05-20 06:18:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Nicolas Lak",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Je recommande ce produit. Livraison rapide.",
    "reply": "",
    "created_at": "2020-05-31 11:16:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Catherine Froment",
    "email": "vincent@sunology.fr",
    "location": "France",
    "body": "Poulet , pains, légumes......c'est parfait!",
    "reply": "",
    "created_at": "2020-07-10 17:23:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Manu",
    "email": "manu@delgoffe.net",
    "location": "France",
    "body": "Au soleil c'est vraiment top. Le volume nous permet de cuisiner un plat pour 6 sans trop de soucis. Lors d'une journée ensoleillée, nous pouvons faire jusqu'à 4 cuissons. Par contre, branché en 12V sur l'allume cigare de la voiture, ça n'a jamais chauffé correctement. Apparemment, la sortie 12V ne sort pas la bonne puissance dans une voiture française. Probablement que c'est différent sur un camping car ? Malgré cela je ne regrette pas mon achat! Quant au service client, il est top : livraison très rapide, dialogue toujours courtois et éclairant, explications claires et professionnelles. ... Cette boutique mérite vraiment qu'on en fasse la publicité et je ne m'en priverai pas!",
    "reply": "",
    "created_at": "2020-07-12 15:16:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Sylvie Roulier",
    "email": "vincent@sunology.fr",
    "location": "France",
    "body": "Fonctionne du tonnerre. Seulement 5 minutes pour faire bouillir 3 l'eau froide. L'utilisation du thermostat intelligent est vraiment un peu pour éviter d'avoir à surveiller la cuisson.",
    "reply": "",
    "created_at": "2020-07-15 13:06:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Dominique",
    "email": "natacha.janot@free.fr",
    "location": "France",
    "body": "Produit top design et top efficacité, on peut rôtir comme dans un four traditionnel, griller comme au barbecue, cuire de la pàtisserie (ma fille organise des Muffingardenparty).",
    "reply": "",
    "created_at": "2020-07-21 18:21:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-fusion",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Cathy Lamy",
    "email": "vincent@sunology.fr",
    "location": "France",
    "body": "Four solaire incroyable. Excellent filet de porc avec pommes de terre rouges et carottes. Oeufs brouillés. Filets de saumon. Tout cuit à la perfection",
    "reply": "",
    "created_at": "2020-07-24 07:52:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-go",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Lucie Leroux",
    "email": "vincent@sunology.fr",
    "location": "France",
    "body": "Livraison rapide. La cuisson à 360 degrés donne vraiment plus de goût aux aliments.",
    "reply": "",
    "created_at": "2020-06-24 06:53:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-go",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Fred Jarnut",
    "email": "vincent@sunology.fr",
    "location": "France",
    "body": "Pour 2, c'est vraiment le top ! On peut manger et boire chaud où on veut. Nickel !!",
    "reply": "",
    "created_at": "2020-07-16 14:41:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-go",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Jean Doux",
    "email": "vincent@sunology.fr",
    "location": "France",
    "body": "Fonctionne très bien, même pour faire bouillir l'eau. Satisfait.",
    "reply": "",
    "created_at": "2020-07-10 17:19:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-go",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Géraldine",
    "email": "julie.larousse@sfr.fr",
    "location": "France",
    "body": "Léger et simple à utiliser, une belle découverte !",
    "reply": "",
    "created_at": "2020-07-10 17:24:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-go",
    "state": "published",
    "rating": 3,
    "title": "AVIS",
    "author": "Gilles Fauvet",
    "email": "vincent@sunology.fr",
    "location": "France",
    "body": "Ca chauffe vraiment très vite ! Je recommande le Gosun. Côté service, j'aurais aimé une livraison plus rapide : 15 jours d'attente en plein été, c'est long.",
    "reply": "",
    "created_at": "2020-08-11 17:53:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-sport",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Marie-Anne Van",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "J'ai 2 cuiseurs solaires et ils fonctionnent très bien. Ils sont très faciles à utiliser et la nourriture est parmi les meilleures que j'ai jamais goûtée. Le nettoyage est un jeu d'enfant. Si vous n'en avez pas, vous ne savez pas à côté de quoi vous passez.",
    "reply": "",
    "created_at": "2020-02-19 08:32:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-sport",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Cécile Boireau",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Les enfants en sont dingues. Nous avons fait des brownies et des muffins aux poires. Ils étaient très moelleux et fondants, un délice.",
    "reply": "",
    "created_at": "2020-05-05 12:26:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-sport",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Mickaël Nasirian",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Très bon concept. Je l'ai testé 4 fois pour le moment et il a bien fonctionné même si parfois il a manqué un peu d'uniformité dans la cuisson.",
    "reply": "",
    "created_at": "2020-05-06 06:25:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-sport",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Myrddrina Wavelet",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Le design de ce four est génial. Les miroirs à double coques rendent la configuration facile. Les matériaux sont de grande qualité.",
    "reply": "",
    "created_at": "2020-05-08 06:54:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-sport",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Aurélie Maillon",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Je l'ai utilisé presque tous les jours au mois d'avril. Avec le grand soleil qu'il a fait j'ai pu faire des légumes et même du quinoa.",
    "reply": "",
    "created_at": "2020-05-10 05:50:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-sport",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Vanessa Passley",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "J'ai téléchargé une application qui marche très bien pour le positionner au mieux quand il y a des nuages.",
    "reply": "",
    "created_at": "2020-05-13 07:17:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-sport",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Raymond Simoes",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Les temps de cuisson varient en fonction de la météo.",
    "reply": "",
    "created_at": "2020-05-14 05:20:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-sport",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Patrick Audiot",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "C'est un produit très bien conçu et pensé. Il cuisine relativement rapidement si vous ne l'ouvrez pas sans cesse pour regarder votre nourriture.",
    "reply": "",
    "created_at": "2020-05-15 06:21:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-sport",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Erwan Cardozo",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Au début j'étais sceptique sur l'intérêt du Gosun sport et après avoir lu de nombreux avis je me le suis offert et je ne regrette pas du tout.",
    "reply": "",
    "created_at": "2020-05-19 06:06:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-sport",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Lisa Grunda",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Je viens de faire du saumon et il est incroyablement bon. J'ai mis un peu d'huile d'olive et du citron. En 40 minutes il était prêt. On s'est régalé. Et le nettoyage a été fait en un clin d'oeil parce que j'ai mis du papier sulfurisé.",
    "reply": "",
    "created_at": "2020-05-27 06:24:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-sport",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Carole Paulino",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "J'ai vraiment l'impression à mon niveau de faire quelque chose de bien pour la planète depuis que j'ai mon four.",
    "reply": "",
    "created_at": "2020-05-29 07:37:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-sport",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Yacer Bienvenu",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Il fonctionne toujours bien même quand il n'y a pas beaucoup de soleil.",
    "reply": "",
    "created_at": "2020-05-31 11:17:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-sport",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Matthieu Desme",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Je trouve ça très enrichissant de ne consommer aucune énergie fossile comme du gaz ou du charbon.",
    "reply": "",
    "created_at": "2020-06-01 06:21:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-sport",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Anne Sophie M",
    "email": "vincent@sunology.fr",
    "location": "France",
    "body": "La cuisson dans le tube révèle vraiment les saveurs. J'aime bien le principe dépliage/repliage du four. Je peux l'emmener où je veux. Expérience sur la plage concluante :-) Je recommande vraiment ce produit.",
    "reply": "",
    "created_at": "2020-08-03 08:56:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-powerbank",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Raphaelle Gayatri",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Bon produit pour faire marcher le Gosun Fusion quand on n'a pas d'électricité..",
    "reply": "",
    "created_at": "2020-05-06 06:23:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-powerbank",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Joseph Mélanie",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "La batterie est puissante et dure longtemps. Je l'utilise pour de nombreux appareils. Les enfants s'en servent pour charger la tablette sans être obligés de se mettre près d'une prise de courant.",
    "reply": "",
    "created_at": "2020-05-08 06:52:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-powerbank",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Anissa Lamache",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "La batterie est énorme et peut alimenter de nombreuses choses.",
    "reply": "",
    "created_at": "2020-05-12 12:13:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-powerbank",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Morgan Lemann",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Il porte bien son nom. Il a assez de puissance pour faire tourner un ventilateur et une pompe à eau.",
    "reply": "",
    "created_at": "2020-05-18 06:57:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-powerbank",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Anaà¯s Demodice",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "La qualité et la performance sont au rendez-vous. Nous sommes très heureux de notre achat.",
    "reply": "",
    "created_at": "2020-05-20 06:20:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-powerbank",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Christiane Jerry",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Il a été expédié rapidement même par confinement. Bravo.",
    "reply": "",
    "created_at": "2020-05-21 06:49:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-powerbank",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Janine Duflot",
    "email": "vincent@sunology.fr",
    "location": "France",
    "body": "J'avais déjà acheté le Gosun Fusion sur le site. Je voulais pouvoir l'utiliser sans soleil ou la nuit. La batterie permet d'assurer 2 bonnes heures de cuisson. Contente de mon achat.",
    "reply": "",
    "created_at": "2020-07-10 17:28:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-solarflex-30",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Bénédicte Meunier",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "C'est un produit très innovant même s'il est un peu cher je suis contente de mon investissement.",
    "reply": "",
    "created_at": "2020-06-01 06:18:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-solarflex-30",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Jean-François Pilette",
    "email": "vincent@sunology.fr",
    "location": "France",
    "body": "Livraison rapide. Panneau efficace avec la batterie. En moyenne, 8h à Poitiers pour charger complètement la batterie.",
    "reply": "",
    "created_at": "2020-07-16 14:43:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-thermo",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Céline Altmayer",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "C'est trop pratique, j'ai plus besoin de stresser pour la cuisson.",
    "reply": "",
    "created_at": "2020-05-06 06:24:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-thermo",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Caroline Had",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Excellent ajout à l'expérience de cuisson solaire. Je l'ai utilisé une fois et j'ai été très satisfaite des résultats. La température a été suivie parfaitement. Le poulet était délicieux.",
    "reply": "",
    "created_at": "2020-05-08 06:53:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-thermo",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Wendy Guillot",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "J'aime beaucoup mon Thermo et le couplage avec mon i phone marche extrêmement bien. A quand des recettes en français ?",
    "reply": "",
    "created_at": "2020-05-10 05:48:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-thermo",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Walid Martin",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Il a beaucoup de bonnes fonctionnalités, celle qui est la meilleure pour moi. Dommage que les informations dans l'application soient en anglais.",
    "reply": "",
    "created_at": "2020-05-13 07:16:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-thermo",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Florian Berger",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "J'avais utilisé un thermomètre de cuisson classique pour mon Gosun sport mais ça n'a rien à voir avec le Thermo.",
    "reply": "",
    "created_at": "2020-05-15 06:20:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-thermo",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Roxanne Baryan",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Au début je me disais que c'était un gadget inutile quand mon mari l'a acheté. Mais en fait il change complètement la donne et nous sert vraiment.",
    "reply": "",
    "created_at": "2020-05-19 06:05:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-thermo",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Justin Khara",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "L'application intégrée est géniale. Après l'avoir utilisé une dizaine de fois je peux dire que je peux tout cuisiner sans exception sans avoir à me préoccuper du résultat final. Je n'ai pas raté une seule fois depuis que je m'en sers et ça c'est un vrai miracle.",
    "reply": "",
    "created_at": "2020-05-21 06:52:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-thermo",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Astrid Thausing",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Les réglages de températures des aliments sont très utiles surtout qu'on peut les modifier et les personnaliser en fonction de nos goûts. Personnellement je préfère quand les aliments sont croquants.",
    "reply": "",
    "created_at": "2020-05-30 06:18:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "gosun-thermo",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Diana Abdallah",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "J'aime particulièrement le fait de pouvoir régler un minuteur en plus de l'alarme.",
    "reply": "",
    "created_at": "2020-06-01 06:20:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "hanergy-humbrella",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Sylvie Chazelle",
    "email": "julie.larousse@sfr.fr",
    "location": "France",
    "body": "Hyper beau !! Puissance d'éclairage impressionnante.",
    "reply": "",
    "created_at": "2020-07-10 16:49:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "hanergy-humbrella",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Vincent Humbert",
    "email": "vincent@sunology.fr",
    "location": "France",
    "body": "Le prix en vaut la chandelle. L'achat du parasol nous a permis d'éviter de faire des travaux pour mettre une prise électrique et de l'éclairage sur notre terrasse. Il éclaire très bien pendant la nuit et la recharge des téléphones fonctionne parfaitement. Merci au service client pour ses conseils.",
    "reply": "",
    "created_at": "2020-07-15 13:09:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "maiori-couture",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Inès B",
    "email": "julie.larousse@sfr.fr",
    "location": "France",
    "body": "Jolie, super qualité. Dommage pour le délai de livraison un peu long à mon goût !",
    "reply": "",
    "created_at": "2020-06-28 11:00:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "maiori-paris",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Françoise Cain",
    "email": "emmanuel.arrouet@prod-in.fr",
    "location": "France",
    "body": "J'adore ces lampes! Elles donnent du cachet à n'importe quel extérieur la nuit!",
    "reply": "",
    "created_at": "2020-01-09 07:17:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "maiori-paris",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Chantale Marchand",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "J'aime beaucoup le design de ces lumières. Nous les avons mises sur le chemin de notre portail à notre porte d'entrée, nos amis ont adoré. Elles sont arrivées parfaitement dans les temps pour le réveillon.",
    "reply": "",
    "created_at": "2020-01-13 06:11:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "maiori-paris",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Julien Elein",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Je viens de les mettre aujourd'hui. Elles sont telles que je les imaginais en regardant le site. Pour le moment rien de plus à signaler, je posterai à nouveau si quelque chose se passe.",
    "reply": "",
    "created_at": "2020-01-31 07:04:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "maiori-parabole",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Fred",
    "email": "julie.larousse@sfr.fr",
    "location": "France",
    "body": "Juste sublime en intérieur comme en extérieur.",
    "reply": "",
    "created_at": "2020-07-10 17:26:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "maiori-parabole",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Patrick keravec",
    "email": "julie.larousse@sfr.fe",
    "location": "France",
    "body": "Belle lampe pour l'intérieur comme pour l'extérieur . Petit plus elle se détache de son socle ce qui est très pratique.",
    "reply": "",
    "created_at": "2020-07-11 17:32:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "maiori-parabole",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Simon Perez",
    "email": "julie.larousse@sfr.fr",
    "location": "France",
    "body": "Qualité d'éclairage au RDV pour des lampes de chemin. Pilotage des lampes via smartphone est un plus.",
    "reply": "",
    "created_at": "2020-06-15 19:42:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "maiori-petite",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Reda Tahar",
    "email": "julie.larousse@sfr.fr",
    "location": "France",
    "body": "Je l'ai prise en bleue, elle est top. A voir à l'usage pour l'autonomie.",
    "reply": "",
    "created_at": "2020-06-28 10:57:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "maiori-petite",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Julie",
    "email": "julie.larousse@sfr.fr",
    "location": "France",
    "body": "Canon, le sans fil apporte un vrai confort. L'utilisation est super simple (il faut juste penser à recharger sa lampe à l'extérieur...)",
    "reply": "",
    "created_at": "2020-07-11 17:39:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "maiori-pose-02",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Mélanie goiset",
    "email": "julie.larousse@sfr.fr",
    "location": "France",
    "body": "Ces lampes sont de très belle qualité. Le Système de fixation des cellules est très facile à utiliser. Première utilisation lors d'un dîner ce week-end après une journée de charge, je n'étais pas peu fière de les poser en centre de table pour créer une ambiance chaleureuse. Et j'adore ce jaune !!",
    "reply": "",
    "created_at": "2020-06-15 19:35:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "maiori-pose-02",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Arnaud Levy",
    "email": "julie.larousse@sfr.fr",
    "location": "France",
    "body": "Produit top. Super finitions. Livraison rapide.",
    "reply": "",
    "created_at": "2020-06-15 19:40:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "maiori-pose-02",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Tina",
    "email": "julie.larousse@sfr.fr",
    "location": "France",
    "body": "Très sympa. Je recommande.",
    "reply": "",
    "created_at": "2020-06-28 11:12:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "maiori-pose-02",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Jean-Pierre DURIEUX",
    "email": "julie.larousse@sfr.fr",
    "location": "France",
    "body": "Je les ai prise en jaune, super belles, qualité au rendez-vous, même si un peu cher à mon goût.",
    "reply": "",
    "created_at": "2020-07-10 17:30:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "powerfilm-lightsaver",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Marc-Antoine Pulvar",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Super Léger. Excellente batterie mince comme du papier. Ce produit est tout simplement génial.",
    "reply": "",
    "created_at": "2020-05-26 05:13:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "powerfilm-lightsaver",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Sarah Gire",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Cette batterie est parfaite pour faire de grandes sorties et des treks. Elle charge très bien au soleil et elle fournit une grande autonomie.",
    "reply": "",
    "created_at": "2020-05-28 06:32:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "powerfilm-lightsaver",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Kévin Bernard",
    "email": "vincent@sunology.fr",
    "location": "France",
    "body": "Bien que le prix soit élevé, les performances sont au rendez vous. La meilleure utilisation est en randonnée avec le chargeur accroché au sac à dos. Matériel très résistant.",
    "reply": "",
    "created_at": "2020-07-15 13:13:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "powerfilm-lightsaver-max",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Boris Chamsky",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Produit très bien pensé dans la conception et le fonctionnement. Je l'ai acheté parce qu'il est petit et léger. Je bouge beaucoup en temps normal. Je cherchais quelque chose pour charger de petits appareils. Il s'agit ici d'une batterie compacte qui peut tout charger même quand il y a des nuages.",
    "reply": "",
    "created_at": "2020-05-11 04:48:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "powerfilm-lightsaver-max",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Ariel Piery",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Pensez à vous munir d'un càble pour charger votre portable.",
    "reply": "",
    "created_at": "2020-05-19 06:12:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "powerfilm-lightsaver-max",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Eddy Bourdon",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Très beau chargeur solaire, ultraléger, capable de charger à l'ombre. Je suis un grand fan.",
    "reply": "",
    "created_at": "2020-05-22 08:09:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "powerfilm-lightsaver-max",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Roman Lachance",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Il est facile à transporter mais comme il n'est pas étanche il ne peut être utilisé que sous surveillance. On ne peut pas le laisser dehors tout le temps. Faut faire attention à la météo. à‡a serait bien de penser à un prochain produit étanche.",
    "reply": "",
    "created_at": "2020-05-23 10:44:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "powerfilm-lightsaver-max",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Béatrice Grenouiller",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Dès qu'il y a du soleil il stocke l'énergie et je peux l'utiliser après dès que j'en ai besoin. Son nom n'est pas là juste pour le marketing il conserve bien la lumière.",
    "reply": "",
    "created_at": "2020-05-24 05:16:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "powerfilm-lightsaver-max",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Dimitri Gramont",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Le lightsaver utilise le soleil pour charger la batterie qui après s'occupe de charger le téléphone ce qui est beaucoup plus élaboré que la plupart des chargeurs solaires qui ne marchent pas. Avec celui-ci je n'ai jamais eu de problème depuis que je l'ai acheté il y a deux mois.",
    "reply": "",
    "created_at": "2020-05-25 06:57:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "powerfilm-lightsaver-max",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Richard Beaujardin",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "C'est un ami qui me la recommandé. Les commentaires avaient l'air bon et je dois dire que je ne suis pas déçu par cet achat. Le design est génial et le concept aussi.",
    "reply": "",
    "created_at": "2020-05-28 06:34:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "powerfilm-lightsaver-max",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Stéphanie Cabaux",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "C'est un excellent produit : très robuste, portable qui recharge mon téléphone portable correctement.",
    "reply": "",
    "created_at": "2020-05-29 07:32:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "powerfilm-lightsaver-max",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Marc Simonet",
    "email": "julie.larousse@sfr.fr",
    "location": "France",
    "body": "Livraison rapide. Produit conforme à la description.",
    "reply": "",
    "created_at": "2020-06-28 10:55:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-qwnn",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Sandrine Thibaut",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "J'ai reçu mes 2 lampes QWNN et je les utilise régulièrement. Je suis heureuse d'avoir le port USB pour pouvoir charger des choses.",
    "reply": "",
    "created_at": "2020-05-09 06:34:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-qwnn",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Nathan Mayol",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Elle est très élégante on la pose soit dans sa forme couronne soit en cube et on la suspend dans nos arbres.",
    "reply": "",
    "created_at": "2020-05-11 04:45:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-qwnn",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Alicia Bene",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "C'est un très beau cadeau pour quelqu'un qui vit à la campagne.",
    "reply": "",
    "created_at": "2020-05-21 06:53:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-qwnn",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Charlotte Riaud",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Je l'utilise quotidiennement pour sortir mon chien la nuit.",
    "reply": "",
    "created_at": "2020-05-29 07:29:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-qwnn",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Alain H",
    "email": "julie.larousse@sfr.fr",
    "location": "France",
    "body": "Lumière d'ambiance sympa et chargeur de téléphone pratique mais un peu cher",
    "reply": "",
    "created_at": "2020-06-28 10:51:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-qwnn",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Julie Larousse",
    "email": "vincent@sunology.fr",
    "location": "France",
    "body": "Pas déçue. L'autonomie est très satisfaisante et le principe vraiment original. Je recommande.",
    "reply": "",
    "created_at": "2020-07-16 14:39:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-ww",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Joseph Dumont",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Top ! Livraison très rapide. Produit parfait !",
    "reply": "",
    "created_at": "2020-01-17 07:14:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-ww",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Corinne Sabin",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Je l'ai utilisé au cours d'une randonnée, elle est très légère, se recharge rapidement, et a une bonne autonomie d'éclairage. Un peu chère malgré tout à mon goût!",
    "reply": "",
    "created_at": "2020-01-27 07:08:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-ww",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Colombe Lemat",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "L'effet des lampes a dépassé mes attentes. J'en ai acheté deux blanches et deux couleur charbon. En moins de 48 heures, les elles avaient conservé suffisamment de lumière solaire pour s'allumer la nuit. Je recommanderais ce produit à tous ceux qui veulent égayer leur jardin.",
    "reply": "",
    "created_at": "2020-01-28 07:10:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-ww",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Martin Roul",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Cette lanterne émet une belle qualité de la lumière chaude. Je la charge pendant une journée au soleil et elle dure toute la nuit, même quand il ne fait pas beau.",
    "reply": "",
    "created_at": "2020-02-01 10:54:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-ww",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Karim Vila",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Nous avons 3 Solight Solar Puffs et ils nous sauvé pendant une panne de courant dans notre quartier la semaine dernière.",
    "reply": "",
    "created_at": "2020-02-13 07:59:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-ww",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "William Resey",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Excellente idée cadeau.",
    "reply": "",
    "created_at": "2020-02-23 07:58:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-ww",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Jacques Buchet",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Lampe très design et fonctionnelle avec plein de possibilités d'usages.",
    "reply": "",
    "created_at": "2020-02-24 06:40:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-ww",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Charlène Dong",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Cette lampe est idéale pour le camping ou pour chez soi.",
    "reply": "",
    "created_at": "2020-03-02 08:25:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-ww",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Solène Roy",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Je trouve cette innovation très utile et j'espère que de plus en plus de personnes puissent en bénéficier.",
    "reply": "",
    "created_at": "2020-03-03 08:13:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-ww",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Charles Dormoy",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Très bonne autonomie chargée, légère comme une plume et éclairage lumineux sans être éblouissant. Je pense que je vais très vite en recommander 1 ou 2.",
    "reply": "",
    "created_at": "2020-03-04 08:45:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-ww",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Gérard Villeneuve",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Pratique et très peu encombrant.",
    "reply": "",
    "created_at": "2020-03-05 07:53:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-ww",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Maggy Mignac",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Brillante petite lumière!",
    "reply": "",
    "created_at": "2020-03-05 07:53:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-ww",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Amélina Elbaz",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "J'ai enfin trouvé une lampe avec de l'énergie pour ma terrasse. Elle illumine beaucoup pour sa taille. J'espère que ça durera.",
    "reply": "",
    "created_at": "2020-05-15 06:22:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-ww",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Eliot Mottin",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Ce produit est très utile, il se recharge au soleil directement et peut être stocké facilement. En plus il n'utilise pas d'énergie électrique, ne pèse rien et résiste à l'eau.",
    "reply": "",
    "created_at": "2020-05-19 06:08:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-ww",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Isabelle Kety",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Le Solarpuff fournit beaucoup de lumière même dans le mode le plus faible. Il faut attendre d'avoir épuiser la 1ère charge et pour le recharger.",
    "reply": "",
    "created_at": "2020-05-30 06:20:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-ww",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Josseline Vigouroux",
    "email": "vincent@sunology.fr",
    "location": "France",
    "body": "La livraison a été rapide. J'utilise la lampe pour éclairer la table de terrasse la nuit. Je vais aussi l'emmener en camping. A suivre.",
    "reply": "",
    "created_at": "2020-07-15 13:11:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-ww",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Pascale",
    "email": "julie.larousse@sfr.fr",
    "location": "France",
    "body": "J'ai pris le pack 4+1 comme ça chacun a la sienne à la maison. C'était top de les avoir en camping et maintenant elles éclairent la terrasse. Le prix reste abordable, je recommande.",
    "reply": "",
    "created_at": "2020-08-07 13:50:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-merlin",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Laura Tometti",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Produit de qualité ! je suis satisfaite de ma commande.",
    "reply": "",
    "created_at": "2020-01-17 07:15:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-merlin",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Margaux Chevalet",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Je le place juste devant ma terrasse et il crée une ambiance parfaite la nuit.",
    "reply": "",
    "created_at": "2020-03-06 09:14:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-merlin",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Jérôme Delacroix",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "J'aime ce produit.",
    "reply": "",
    "created_at": "2020-03-07 11:08:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-merlin",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Karine Blanc",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "J'ai acheté cette lampe parce que je vis à la campagne et je m'occupe d'animaux. Et je n'ai pas de courant électrique partout sur mon terrain. Malgré sa petite taille elle émet une bonne quantité de lumière.",
    "reply": "",
    "created_at": "2020-05-09 06:33:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-merlin",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Fanny Crénel",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Nous avons acheté cette lumière supère légère et portable pour nos vacances en camping. On espère pouvoir bientôt l'utiliser. En attendant on l'a mise dans notre jardin pour diner le soir. Nous l'avons utilisé une fois et elle éclaire très bien.",
    "reply": "",
    "created_at": "2020-05-10 05:53:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-merlin",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Bertrand à‰baire",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Je l'ai acheté parce que mon amie l'avait. Sa lumière est très agréable, elle peut même éclairer quand il fait complètement noir. à‡a sert de veilleuse à ma fille de 2 ans.",
    "reply": "",
    "created_at": "2020-05-14 05:23:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-merlin",
    "state": "published",
    "rating": 3,
    "title": "AVIS",
    "author": "Chloé Payet",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "La lumière est assez blanche contrairement à ce que montre l'image mais la lampe marche bien.",
    "reply": "",
    "created_at": "2020-05-14 05:24:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-merlin",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Marion Bizjak",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "La Merlin est vraiment bien conçue pour son prix et elle flotte sur l'eau.",
    "reply": "",
    "created_at": "2020-05-16 06:25:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-merlin",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Alexis Granger",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Je me suis fait plaisir en prenant 4 lampes de la version avec les 6 couleurs. Je les ai placées un peu partout dans mon jardin. à‡a rend super dès que le soleil se couche elles illuminent tout le jardin.",
    "reply": "",
    "created_at": "2020-05-18 07:00:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarpuff-merlin",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Allan Royer",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Super système au led pour un éclairage qui se transporte facilement. Très compacte. Matériaux robustes.",
    "reply": "",
    "created_at": "2020-05-20 06:22:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "sunology-intellisolar",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Maxime Kaminsky",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "J'avais besoin d'un petit système pour ma petite maison et ce panneau transportable convient parfaitement. Il fonctionne très bien et ne prend pas beaucoup de place dans ma cour !",
    "reply": "",
    "created_at": "2020-01-06 19:37:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "sunology-intellisolar",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Cécile Rigot",
    "email": "carolina44@hotmail.fr",
    "location": "France",
    "body": "Bien fait, installation facile",
    "reply": "",
    "created_at": "2020-01-09 07:14:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "sunology-intellisolar",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "ISMAEL",
    "email": "kismael1@9online.fr",
    "location": "France",
    "body": "commande de deux panneaux , installation au sol, très bonne réaction (sms ou phone) aux questions pour les divers branchements , étant novice en solaire , je recommanderais ce produit a mon entourage en plus facile a poser et a mettre en route .",
    "reply": "",
    "created_at": "2020-01-10 14:13:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "sunology-intellisolar",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Emmanuel Lamy",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Exactement ce que je cherchais.",
    "reply": "",
    "created_at": "2020-01-11 07:34:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "sunology-intellisolar",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Agnès Verde",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "J'en ai acheté 3 et je suis très heureuse! J'étais nerveuse à l'idée d'acheter quelque chose que je devrais installer moi-même, mais en fait c'était beaucoup plus facile que prévu.",
    "reply": "",
    "created_at": "2020-01-21 08:15:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "sunology-intellisolar",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Laurent Daniel",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Nous avons pu le faire fonctionner en un rien de temps. Je recommande sincèrement et je vais en acheter un autre bientôt.",
    "reply": "",
    "created_at": "2020-01-26 09:07:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "sunology-intellisolar",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Florian Capilliez",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Bon produit mais il manque une batterie pour stocker l'énergie de la journée pour plus tard.",
    "reply": "",
    "created_at": "2020-02-06 08:57:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "sunology-intellisolar",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Baptiste Champion",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "J'ai une terrasse à très faible pente et j'ai toujours voulu m'équiper en solaire. J'en ai acheté 1. Il m'a fallu plus de temps pour me décider où je voulais le mettre que pour l'installer. Jusqu'ici tout va très bien!",
    "reply": "",
    "created_at": "2020-02-09 16:00:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "sunology-intellisolar",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Nelly Coulomb",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "On est plutôt content. On aurait aimé avoir des prises à l'arrière du panneau pour brancher des appareils électriques quand on transporte le panneau dans notre camping car.",
    "reply": "",
    "created_at": "2020-02-12 07:47:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "sunology-intellisolar",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Marie Lome",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Très belle innovation. à‡a change des panneaux sur les toitures.",
    "reply": "",
    "created_at": "2020-05-05 12:24:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "sunology-intellisolar",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Christophe Vaillard",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Je découvre la vie en autoconsommation et je suis très content.",
    "reply": "",
    "created_at": "2020-05-06 06:21:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "sunology-intellisolar",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Gilles Pardon",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Je ne pensais pas qu'un panneau seul pouvait avoir une telle puissance. Je suis plus que satisfait de mon achat.",
    "reply": "",
    "created_at": "2020-05-07 07:57:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "sunology-intellisolar",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Mathieu Conty",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Je n'avais pas envie de payer une installation solaire des milliers d'euros et faire appel à un artisan. Quand je suis tombé sur easy solar plug and play j'étais très content. Le rapport service-prix est excellent.",
    "reply": "",
    "created_at": "2020-05-08 06:50:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "sunology-intellisolar",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Maxime Cloche",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "La commande a été facile et easy solar fonctionne bien. Il manque juste une solution pour brancher le panneau sur mon camping car.",
    "reply": "",
    "created_at": "2020-05-13 07:12:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "sunology-intellisolar",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Aziza Omri",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "J'avais un peu peur d'investir dans du solaire avec toutes les polémiques. On m'a donné les réponses à toutes mes questions et après une semaine de réflexion j'ai acheté 2 panneaux. à‡a vaut vraiment le coup d'investir.",
    "reply": "",
    "created_at": "2020-05-18 06:55:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "sunology-intellisolar",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Léonard Benel",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Il me fait économiser de l'argent chaque mois et je suis plus conscient de ma consommation d'énergie. Je recommande fortement ce produit à toutes les personnes intéressées par le solaire.",
    "reply": "",
    "created_at": "2020-05-27 06:20:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "sunology-intellisolar",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Léa Jordy",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Très facile à installer cela m'a pris que quelques minutes.",
    "reply": "",
    "created_at": "2020-05-30 06:16:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "sunology-intellisolar",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Sylvain Lamy",
    "email": "julie.larousse@sfr.fr",
    "location": "France",
    "body": "Super facile à installer. Service client pro et réactif.",
    "reply": "",
    "created_at": "2020-07-10 16:45:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "sunology-intellisolar",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Yann Ivray",
    "email": "vincent@sunology.fr",
    "location": "France",
    "body": "L'installation du panneau a pris 5 minutes. Le plus long a été la mise en place d'une prise de courant extérieur que je n'avais pas. Je recommande !",
    "reply": "",
    "created_at": "2020-07-15 13:04:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "sunology-intellisolar",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Goeffrey Limans",
    "email": "vincent@sunology.fr",
    "location": "France",
    "body": "La livraison a été très rapide: 2 jours. Le conditionnement sur palette fait vraiment sérieux. Le système se branche très vite. On attend maintenant l'accessoire qui va permettre de bien compter notre production.",
    "reply": "",
    "created_at": "2020-07-16 14:36:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "sunology-intellisolar",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "José Fernandes",
    "email": "vincent@sunology.fr",
    "location": "France",
    "body": "Commandé le dimanche, livré le mardi. Vraiment top question rapidité ! Le montage est tout simple. Se référer à la notice en ligne car celle qui est dans le carton est en anglais.",
    "reply": "",
    "created_at": "2020-08-03 08:53:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "sunology-intellisolar",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Burriez guillaume",
    "email": "burriez@hotmail.com",
    "location": "France",
    "body": "Produit innovant, livraison ultra rapide et équipe dispo et bienveillante pour répondre aux questions. Très bonne expérience. Je conseille vivement.",
    "reply": "",
    "created_at": "2020-08-17 11:59:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "sunology-intellisolar",
    "state": "published",
    "rating": 3,
    "title": "AVIS",
    "author": "Ledelay",
    "email": "david.ledelay@gmail.com",
    "location": "France",
    "body": "Bonjour , Un bon produit Mais le service livraison défaillant il est nécessaire de rectifier ce moyen de livraison  Prévu 48 h la 1 semaine d attente ( j ai pas eu De chance ) à revoir Le service répond à nos questions",
    "reply": "",
    "created_at": "2020-09-21 17:16:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Patrice Nguyen",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "J'adore ce sac à dos. Je voyage beaucoup en avion et ce n'est pas toujours facile d'avoir un sac passe partout dans lequel je peux mettre toutes mes affaires. Il se cale parfaitement sous les sièges d'avion et il y a beaucoup d'espace à l'intérieur car la batterie est très bien placée. Franchement super produit que je recommande à tous les voyageurs !",
    "reply": "",
    "created_at": "2020-01-10 16:19:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Teddy Rasay",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Bon produit.",
    "reply": "",
    "created_at": "2020-01-20 08:13:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Isabelle Marie",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Je l'ai acheté pour mon frère qui est un grand fan de technologie et de développement durable. C'était le cadeau parfait surtout pour lui qui voyage aussi beaucoup. Il était ravi.",
    "reply": "",
    "created_at": "2020-01-24 09:48:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Pierre Andria",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "J'ai acheté le sac à dos Solar Array il y a 1 mois. Je n'ai plus besoin de me soucier de l'alimentation principale utilisée pour les téléphones, j'ai plus besoin d'avoir une petite batterie portable. Le sac est de taille standard et je n'ai aucun problème de stockage. Il ne pèse vraiment rien de plus qu'un sac normal lorsqu'il est sur le dos.",
    "reply": "",
    "created_at": "2020-02-02 10:22:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Marisa Serra",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "N'oubliez pas de débrancher la batterie lorsqu'elle est complètement chargée.",
    "reply": "",
    "created_at": "2020-02-03 06:38:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Rodrigue Bernier",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "J'aime beaucoup la façon dont le sac à dos est conçu, il est semi-rigide, s'ouvre par le haut. J'accède facilement à tout et les compartiments et les poches permettent d'isoler les objets.",
    "reply": "",
    "created_at": "2020-02-13 08:02:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Sarah Berteau",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Je suis partie en vacances une semaine avec mon sac. J'ai chargé la batterie la nuit et l'énergie solaire a maintenu la batterie toute la journée. De tout ce que j'ai acheté depuis un an c'est le plus pratique et je pense que ça va le rester encore un certain temps.",
    "reply": "",
    "created_at": "2020-02-15 10:05:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Nicolas Mansana",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Le seul point négatif du sac c'est que les gens me posent toujours des questions soit parce qu'ils ne connaissent pas du tout soit parce qu'ils veulent en acheter un. Sinon tout est nickel.",
    "reply": "",
    "created_at": "2020-02-24 06:38:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Jean Coutant",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Il est de très bonne qualité et les panneaux chargent la batterie même par le ciel gris et pluvieux parisien. Bravo Voltaics!",
    "reply": "",
    "created_at": "2020-02-26 07:53:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 3,
    "title": "AVIS",
    "author": "Geoffroy Abiker",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Prix un peu trop élevé mais bonne qualité quand même.",
    "reply": "",
    "created_at": "2020-02-26 07:56:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Karine Severin",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "La batterie est très bonne, capable de recharger n'importe quoi, des téléphones portables, des appareils GPS aux appareils photo et ordinateurs portables.",
    "reply": "",
    "created_at": "2020-02-27 07:09:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Jade Deschamps",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Les fermetures à glissière et les fils semblent être de très bonne qualité et d'après l'expérience que j'ai avec d'autres sacs à dos, je sais dès maintenant que ceux-ci résisteront au temps et à l'utilisation.",
    "reply": "",
    "created_at": "2020-02-28 09:49:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Achille Coulaud",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Dans l'ensemble, c'est un excellent produit pour ceux qui aiment sortir dans la nature, mais ne peuvent pas vivre sans la technologie.",
    "reply": "",
    "created_at": "2020-02-29 12:54:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Anne-Marie Estarque",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Assez grand pour un sac à dos et assez petit pour ne pas être un fardeau.",
    "reply": "",
    "created_at": "2020-03-02 08:27:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Aymeric Bonnet",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Ce que je vais dire ne va peut-être pas vous servir mais je le dis quand même. Bravo aux créateurs.",
    "reply": "",
    "created_at": "2020-03-03 08:11:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Flavien Lenouël",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Une taille très convenable.",
    "reply": "",
    "created_at": "2020-03-04 08:42:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Clovis Medji",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Je cherchais un sac à dos au moins résistant à la pluie et celui-ci s'adapte très bien à toutes les conditions climatiques. Il est très spacieux et robuste.",
    "reply": "",
    "created_at": "2020-03-04 08:43:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Joffrey Dewet",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Expérience fantastique. Excellent produit.",
    "reply": "",
    "created_at": "2020-03-07 11:06:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Clarisse Martin",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Fabrication de qualité, efficacité remarquable.",
    "reply": "",
    "created_at": "2020-03-07 11:07:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Aranud Donou",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Ce sac à dos solaire avec batterie intégrée et chargeur solaire est génial. Il a suffisamment de puissance pour recharger mon MacBookPro. Il dispose d'un énorme espace intérieur pour les équipements et la batterie est fine.",
    "reply": "",
    "created_at": "2020-05-16 06:40:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Osman Louchi",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Solide construction et compartiments rembourrés pour les ordinateurs et les appareils photo. Elle protège tout le matériel technologique. Rien à voir avec les sacs à dos classiques.",
    "reply": "",
    "created_at": "2020-05-19 06:09:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Johanna Nebout",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Je suis très heureuse de la taille de mon sac à dos. La batterie tient bien la charge. Le seul problème que l'anse qui permet de l'attraper n'a pas l'air très solide. Sinon il est d'une très bonne qualité.",
    "reply": "",
    "created_at": "2020-05-26 05:15:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "à‰lise Poli",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Fonctionne parfaitement, très satisfaite des capacités de charge et des performances de la batterie.",
    "reply": "",
    "created_at": "2020-05-30 06:21:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Albin Petit",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Je suis extrêmement content de ce modèle.",
    "reply": "",
    "created_at": "2020-06-01 06:24:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-array",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Denault judith",
    "email": "julie.larousse@sfr.fr",
    "location": "France",
    "body": "Sac grand volume et très logeable avec ses nombreuses poches. Je suis impressionnée par la vitesse de recharge de mon smart phone avec la batterie amovible (50% de charge en 20 min). C'est un grand confort de pouvoir recharger son téléphone /pc partout sans contrainte de prise ????",
    "reply": "",
    "created_at": "2020-06-15 19:27:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-converter",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Loà¯c Dufresne",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Panneau solaire de bonne puissance. Même pas besoin d'être dehors au soleil pour qu'il charge, à l'intérieur près d'une fenêtre ça suffit.",
    "reply": "",
    "created_at": "2020-05-16 06:45:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-converter",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Gary Genest",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Je ne pense pas que vous puissiez vous tromper avec ce sac pour moi c'est le meilleur sac à dos solaire du marché.",
    "reply": "",
    "created_at": "2020-05-22 08:12:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-converter",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Florent Machado",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Ce sac est super. Il fonctionne comme indiqué sur le site et garde mon téléphone chargé quand je me balade.",
    "reply": "",
    "created_at": "2020-05-24 05:21:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-converter",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "David Madaric",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Il est plus volumineux que ce à quoi je m'attendais.",
    "reply": "",
    "created_at": "2020-05-25 06:59:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-converter",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Bilal Herbens",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Produit parfait pour les déplacements professionnels quotidiens ou les excursions et les week-end. Facile à transporter avec beaucoup de poches.",
    "reply": "",
    "created_at": "2020-05-28 06:26:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-converter",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Jessica Anka",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "C'est un sac génial. Il est parfait pour transporter mon MacBook sans être endommagé. Même si je vis dans une région assez nuageuse, il charge en un rien de temps.",
    "reply": "",
    "created_at": "2020-06-01 06:26:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-fuse-laptop",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Charles Henry",
    "email": "julie.larousse@sfr.fr",
    "location": "France",
    "body": "Je suis fan ! Parfait pour transporter et recharger mon PC.",
    "reply": "",
    "created_at": "2020-06-28 11:09:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-fuse-laptop",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Jimmy Paris",
    "email": "julie.larousse@sfr.fr",
    "location": "France",
    "body": "Produit conforme à la description. Dommage pour le délai de livraison.",
    "reply": "",
    "created_at": "2020-07-10 17:05:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-offgrid",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Romain Belliot",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Pas déçu par ce sac à dos ! Les bretelles sont très larges, cela répartit le poids sur les épaules de façon homogène. Pour un sac de 25 litres, je suis surpris par la multitude de petites poches intérieures et extérieures. Je peux caler mes càbles, mon portefeuille, mon portable et mon disque dur sans problème. Super boulot.",
    "reply": "",
    "created_at": "2020-05-15 06:24:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-offgrid",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Clément Fourquet",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Sac à dos incroyable ! Je peux facilement adapter tout mon équipement de photo et de vidéo. C'est le sac à dos que j'attendais. Confortable, pratique, élégant. Le panneau solaire et le chargeur sont incroyables. Je n'ai jamais eu de chargeur portable aussi rapide.",
    "reply": "",
    "created_at": "2020-05-22 08:13:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-offgrid",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Rodolphe Pamphile",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Je suis heureux car il est super et votre service excellent et rapide.",
    "reply": "",
    "created_at": "2020-05-23 10:42:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-offgrid",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Leà¯la Daniel",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Le panneau solaire fait bien le travail et le plexiglas qui le protège est de bonne qualité. La batterie peut être rechargée via le panneau, tout en rechargeant le téléphone via un port d'ordinateur. Il me faut un peu moins de 4 heures pour recharger complètement la batterie de mon téléphone.",
    "reply": "",
    "created_at": "2020-05-24 05:22:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-offgrid",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Mathias Laloux",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Je viens de le recevoir. Sac bien fait. Il a l'air vraiment bien de près. Le compartiment principal est de bonne forme et de bonne taille. Je peux mettre un ordinateur portable et un autre ordinateur portable dans la pochette rembourrée. La batterie charge rapidement mon smartphone. Idéal pour moi car je suis dehors et souvent sur un vélo.",
    "reply": "",
    "created_at": "2020-05-25 07:02:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "voltaic-offgrid",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Luigi Hariche",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "J'adore mon sac à dos solaire. Puisque nous vivons dans le sud de la France, je l'emporte partout avec moi. Je n'arrête pas de dire à tout le monde qu'ils doivent en avoir un.",
    "reply": "",
    "created_at": "2020-06-01 06:25:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "yolk-solar-paper",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Vincent Arrouet",
    "email": "vincent@sunology.fr",
    "location": "France",
    "body": "Mon attente a été pleinement satisfaite! Le système pour replier les modules solaires par aimant est génial!",
    "reply": "",
    "created_at": "2019-12-14 08:47:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "yolk-solar-paper",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Paul Besnard",
    "email": "pa@calachampa.online",
    "location": "France",
    "body": "Utilisez toujours les charnières en silicone incluses, elles n'ajoutent aucun poids réel et maintiennent les panneaux ensemble assez bien.",
    "reply": "",
    "created_at": "2020-01-07 17:59:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "yolk-solar-paper",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Alix Deneuve",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Le produit est durable et très léger. Je charge mes écouteurs bluetooth et mon portable avec. Comme ça je suis tranquille partout où je vais, je suis sûre que je ne tombe jamais en rade de batterie.",
    "reply": "",
    "created_at": "2020-01-14 18:00:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "yolk-solar-paper",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "à‰li Guillon",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Des panneaux supplémentaires sont disponibles pour augmenter la tension.",
    "reply": "",
    "created_at": "2020-01-23 10:32:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "yolk-solar-paper",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Kevin Acoua",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Sous un bon soleil, il a chargé mon iPhone en moins de 3 heures, il dispose d'une excellente fonction de redémarrage automatique qui n'interrompt pas la charge.",
    "reply": "",
    "created_at": "2020-02-09 16:04:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "yolk-solar-paper",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Erika Asaré",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Il fonctionne très bien. J'ai mon papier solaire accroché à mon sac à dos et je charge ma batterie pendant que je marche et que je prends des photos avec mon téléphone. Ensuite, je peux charger la nuit. C'est tellement pratique à emporter et super léger.",
    "reply": "",
    "created_at": "2020-02-17 11:02:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "yolk-solar-paper",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Jean-François Poleux",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "C'est peut-être le panneau le plus léger et le plus efficace que je possède.",
    "reply": "",
    "created_at": "2020-02-20 08:57:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "yolk-solar-paper",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Hervé Guillon",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Très bon produit.",
    "reply": "",
    "created_at": "2020-02-27 07:06:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "yolk-solar-paper",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Henri Delvin",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "J'ai pu recharger mon téléphone directement en fin d'après-midi en plein soleil, il a été chargé à 50% en 1 heure et demie !",
    "reply": "",
    "created_at": "2020-05-10 05:56:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "yolk-solar-paper",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Zoé Fontaine",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Formidable, très recommandable.",
    "reply": "",
    "created_at": "2020-05-11 04:49:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "yolk-solar-paper",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Paul Demey",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Il faut être vigilant et rester proche du four. J'ai mis du bacon à frire un matin et j'ai reçu un appel. Je suis revenu 15 minutes plus tard le bacon était complètement cràmé. Faites attention à bien régler les minuteurs pour vérifier souvent où en est la cuisson.",
    "reply": "",
    "created_at": "2020-05-12 12:16:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "yolk-solar-paper",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Lionel Brassart",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Très bon service client, rapidité de livraisons et le produit est exactement comme sur le site.",
    "reply": "",
    "created_at": "2020-05-22 08:11:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "yolk-solar-paper",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Noël Fabian",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "J'ai reçu ma commande hier. La situation que nous traversons ne l'a pas retardé. Je n'ai pas encore eu le temps à cause de la pluie d'utiliser le Yolk Solar Paper. Je poste un avis dès que je le fais fonctionner.",
    "reply": "",
    "created_at": "2020-05-24 05:19:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "yolk-solar-paper",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Chris Ngoma",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Le produit est en parfait état.",
    "reply": "",
    "created_at": "2020-05-25 06:58:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "yolk-solar-paper",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Pierre",
    "email": "julie.larousse@sfr.fr",
    "location": "France",
    "body": "Bien reçu. J'ai pris la version 3 panneaux, téléphone chargé en moins de 2 h au soleil. Simple à utiliser et performant.",
    "reply": "",
    "created_at": "2020-07-11 17:21:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-origins-green-witch",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Brice Grillou",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Au début je me demandais si l'aiguille des secondes n'allait pas gàcher le produit et bien pas du tout en fait je me suis habitué très vite au style épuré de la montre. Et les 2 aiguilles lui donne un style unique et très élégant.",
    "reply": "",
    "created_at": "2020-02-18 06:52:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-origins-moon-black",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Mike Weber",
    "email": "arrouet.caroline@hotmail.fr",
    "location": "France",
    "body": "Merci à ma femme pour ce superbe cadeau de Noël. Je ne connaissais pas du tout cette marque et maintenant j'ai hàte d'en avoir une autre.",
    "reply": "",
    "created_at": "2020-01-06 19:46:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "awake-origins-moon-black",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Sasha Seroussi",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Je suis trop fier de porter une montre entièrement fabriquée avec des matériaux recyclés. Moi qui suis un fervent écologiste elle me sert de prétexte pour parler de ce sujet qui me tient à coeur.",
    "reply": "",
    "created_at": "2020-05-10 05:51:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarhelix-ww",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Omar Zerouki",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Je la pose sur la table ou je la cale dans un arbre dans mon jardin près de la table. Je m'en sers aussi dès qu'il fait nuit en mode portative pour m'éclairer. Elle fait très bien le job.",
    "reply": "",
    "created_at": "2020-03-04 08:44:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarhelix-ww",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Mélodie Rogier",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Cette petite lanterne nomade est tout simplement géniale !!!",
    "reply": "",
    "created_at": "2020-03-06 09:13:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarhelix-ww",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Jean-Philippe Roger",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Sa lumière est vive et douce pour les yeux. Elle fonctionne vraiment sans pile ni électricité. C'est parfait.",
    "reply": "",
    "created_at": "2020-05-05 12:29:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarhelix-ww",
    "state": "published",
    "rating": 4,
    "title": "AVIS",
    "author": "Laure Flandre",
    "email": "coachapie@gmail.com",
    "location": "France",
    "body": "Produit de qualité, satisfait de ma commande.",
    "reply": "",
    "created_at": "2020-05-11 04:44:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarhelix-ww",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Carine Houssin",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "J'aime beaucoup sa texture et sa forme très mignonne.",
    "reply": "",
    "created_at": "2020-05-20 06:23:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarhelix-ww",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Kevin Daguerre",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "J'ai cette lampe depuis un mois maintenant. Le réglage rouge est particulièrement utile la nuit.",
    "reply": "",
    "created_at": "2020-05-23 07:38:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarhelix-ww",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Lesley Pallier",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "Très pratique pour la nuit en veilleuse devant la chambre de nos enfants.",
    "reply": "",
    "created_at": "2020-05-26 05:16:00 UTC",
    "replied_at": ""
  },
  {
    "product_handle": "solight-solarhelix-ww",
    "state": "published",
    "rating": 5,
    "title": "AVIS",
    "author": "Tim Viry",
    "email": "carolinearrouet@gmail.com",
    "location": "France",
    "body": "J'en ai acheté 2 parce que j'avais vu quelqu'un avec en Festival l'année dernière. Elles sont très amusantes et peuvent être utilisées partout.",
    "reply": "",
    "created_at": "2020-05-27 06:27:00 UTC",
    "replied_at": ""
  }
]);